import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { setCachedImage, addPendingUpload, getPendingUploads, removePendingUpload, getCachedImage, updateAnalysisData, getUserAnalysisData } from "../lib/dexie/helpers";

export default async function FileUpload(userUid, folder, fileName, file, analysisUid = null) {
    const isElectron = typeof window !== 'undefined' && window.electron;
    const isOffline = typeof navigator !== 'undefined' && !navigator.onLine;

    if (isElectron && isOffline && folder === 'custom_imgs' && analysisUid) {
        return await addPendingUpload(userUid, analysisUid, folder, fileName, file);
    }

    const storage = getStorage();
    const fileRef = ref(storage, `/${userUid}/${folder}/${fileName}`);
    await uploadBytes(fileRef, file);
    const url = await getDownloadURL(fileRef);
    if (isElectron) {
        try {
            await setCachedImage(url, file);
        } catch (err) {
            console.error('Erro ao salvar imagem localmente:', err);
        }
    }
    return url;
}

export async function syncPendingUploads(userUid) {
    if (typeof navigator !== 'undefined' && !navigator.onLine) return;
    const uploads = await getPendingUploads(userUid);
    for (const item of uploads) {
        try {
            const blob = await getCachedImage(item.uid);
            if (!blob) continue;
            const url = await FileUpload(userUid, item.folder, item.fileName, blob);
            const data = await getUserAnalysisData(userUid, item.analysisUid);
            if (data && Array.isArray(data.customImages)) {
                const index = data.customImages.indexOf(item.uid);
                if (index !== -1) {
                    const updated = [...data.customImages];
                    updated[index] = url;
                    await updateAnalysisData(userUid, item.analysisUid, { customImages: updated });
                }
            }
            await removePendingUpload(item.uid);
        } catch (err) {
            console.error('Erro ao sincronizar upload pendente:', err);
        }
    }
}